import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoMoh: CultureInfo = {
  name: 'moh',
  displayName: 'Mohawk',
  iso3LanguageCode: 'moh',
  iso2LanguageCode: 'moh',
  ietfLanguageTag: 'moh',
  parent: null
};
